
    import './styles.scoped.css';
    export default {
  "trigger": "awsui_trigger_lpshu_14s66_9",
  "custom": "awsui_custom_lpshu_14s66_15",
  "default": "awsui_default_lpshu_14s66_24",
  "selected": "awsui_selected_lpshu_14s66_40",
  "trigger-wrapper": "awsui_trigger-wrapper_lpshu_14s66_51",
  "dot": "awsui_dot_lpshu_14s66_76"
};
  